import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import Layout from '../components/feature/Layout';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BuyPage = lazy(() => import('../pages/buy/page'));
const BuyersGuidePage = lazy(() => import('../pages/buyers-guide/page'));
const BuyingProcessPage = lazy(() => import('../pages/buying-process/page'));
const SellerGuidePage = lazy(() => import('../pages/seller-guide/page'));
const SellingProcessPage = lazy(() => import('../pages/selling-process/page'));
const HomeValuationPage = lazy(() => import('../pages/home-valuation/page'));
const CommunitiesPage = lazy(() => import('../pages/communities/page'));
const CoralGablesPage = lazy(() => import('../pages/coral-gables/page'));
const CoconutGrovePage = lazy(() => import('../pages/coconut-grove/page'));
const PinecrestPage = lazy(() => import('../pages/pinecrest/page'));
const SouthMiamiPage = lazy(() => import('../pages/south-miami/page'));
const MiamiBeachPage = lazy(() => import('../pages/miami-beach/page'));
const KeyBiscaynePage = lazy(() => import('../pages/key-biscayne/page'));
const BrickellPage = lazy(() => import('../pages/brickell/page'));

const ContactPage = lazy(() => import('../pages/contact/page'));
const ScheduleConsultationPage = lazy(() => import('../pages/schedule-consultation/page'));
const CuratedListingsPage = lazy(() => import('../pages/curated-listings/page'));
const MarketReportsPage = lazy(() => import('../pages/market-reports/page'));
const PrivateExclusivePage = lazy(() => import('../pages/private-exclusive/page'));
const PrivateExclusivesPage = lazy(() => import('../pages/private-exclusives/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const HomeSearchPage = lazy(() => import('../pages/home-search/page'));
const RelocatePage = lazy(() => import('../pages/relocate/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const LlmsTxtPage = lazy(() => import('../pages/llms-txt/page'));
const GatedCommunitiesPage = lazy(() => import('../pages/gated-communities/page'));
const CompleteGuidePage = lazy(() => import('../pages/complete-guide/page'));

const routes: RouteObject[] = [
  {
    path: 'llms.txt',
    element: <LlmsTxtPage />,
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'about-julian',
        element: <AboutPage />,
      },
      {
        path: 'buy',
        element: <BuyPage />,
      },
      {
        path: 'buyers-guide',
        element: <BuyersGuidePage />,
      },
      {
        path: 'buying-process',
        element: <BuyingProcessPage />,
      },
      {
        path: 'seller-guide',
        element: <SellerGuidePage />,
      },
      {
        path: 'selling-process',
        element: <SellingProcessPage />,
      },
      {
        path: 'home-valuation',
        element: <HomeValuationPage />,
      },
      {
        path: 'communities',
        element: <CommunitiesPage />,
      },
      {
        path: 'coral-gables',
        element: <CoralGablesPage />,
      },
      {
        path: 'coral-gables/gated-communities',
        element: <GatedCommunitiesPage />,
      },
      {
        path: 'coral-gables/complete-guide',
        element: <CompleteGuidePage />,
      },
      {
        path: 'coconut-grove',
        element: <CoconutGrovePage />,
      },
      {
        path: 'pinecrest',
        element: <PinecrestPage />,
      },
      {
        path: 'south-miami',
        element: <SouthMiamiPage />,
      },
      {
        path: 'miami-beach',
        element: <MiamiBeachPage />,
      },
      {
        path: 'key-biscayne',
        element: <KeyBiscaynePage />,
      },
      {
        path: 'brickell',
        element: <BrickellPage />,
      },

      {
        path: 'lets-connect',
        element: <ContactPage />,
      },
      {
        path: 'schedule-consultation',
        element: <ScheduleConsultationPage />,
      },
      {
        path: 'buy/curated-listings',
        element: <CuratedListingsPage />,
      },
      {
        path: 'market-reports',
        element: <MarketReportsPage />,
      },
      {
        path: 'private-exclusive',
        element: <PrivateExclusivePage />,
      },
      {
        path: 'private-exclusives',
        element: <PrivateExclusivesPage />,
      },
      {
        path: 'home-search',
        element: <HomeSearchPage />,
      },
      {
        path: 'relocate',
        element: <RelocatePage />,
      },
      {
        path: 'south-florida-relocation',
        element: <RelocatePage />,
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: 'terms-of-service',
        element: <TermsOfServicePage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];

export default routes;
